import { render, staticRenderFns } from "./CategoryCombinedItem.vue?vue&type=template&id=82cd6120&scoped=true&"
import script from "./CategoryCombinedItem.vue?vue&type=script&lang=js&"
export * from "./CategoryCombinedItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCombinedItem.vue?vue&type=style&index=0&id=82cd6120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cd6120",
  null
  
)

export default component.exports